import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { HomeService } from 'src/app/modules/home/home.service';
import { ActivityService } from '../../activity.service';

@Component({
  selector: 'app-workshop-detail',
  templateUrl: './workshop-detail.component.html',
  styleUrls: ['./workshop-detail.component.scss']
})
export class WorkshopDetailComponent implements OnInit {
  isLoading: boolean;
  isTimeExpires: boolean;
  isFull: boolean;
  errorMessage: string;
  registerType = [];
  workshopId: string;
  workshopRegisterForm: FormGroup;
  workshop;
  workshopDetail;
  role: string;

  constructor(
    public matDialog: MatDialog,
    private activityService: ActivityService,
    private fb: FormBuilder,
    private viewportScroller: ViewportScroller,
    private sanitizer: DomSanitizer,
    private homeService: HomeService,
    private router: Router,
    private route: ActivatedRoute,
    private gobalFunctionService: GobalFunctionService
  ) {
    this.workshopRegisterForm = this.fb.group({
      name: ['', Validators.required],
      lastname: ['', Validators.required],
      type: ['', Validators.required],
      affiliate: ['']
    })
  }

  ngOnInit(): void {
    this.isLoading = false;
    this.workshopId = location.href.substring(location.href.lastIndexOf('/') + 1);
    this.activityService.getDetailWorkshop(this.workshopId).pipe(
      switchMap(res => {
        this.isLoading = true;
        this.workshop = res.result;
        this.workshopDetail = this.sanitizer.bypassSecurityTrustHtml(res.result.WORKSHOP_DETAIL);

        let time = new Date();

        if ((new Date(res.result.WORKSHOP_DATE[0].dateTime[0])).getTime() > time.getTime()) {
          this.isTimeExpires = false;
        } else {
          this.isTimeExpires = true;
        }

        if (res.result.COUNT_REGIS < res.result.WORKSHOP_QTY_LEARNERS) {
          this.isFull = false;
        } else {
          this.isFull = true;
        }
        this.gobalFunctionService.setSEO(this.workshop.WORKSHOP_NAME, 'article', this.workshop.WORKSHOP_DETAIL);

        return this.activityService.getAllTypeRegister();
      }),
      map(type => {
        this.registerType = type.result;
      }),
      switchMap(role => {
        return this.homeService.getRole().pipe(
          map(res => {
            this.role = res.result.ROLE;
            // // console.log(this.role);
          })
        )
      }),
      catchError(err => {
        alert(err.error.message);
        return of(null)
      })
    ).subscribe()
  }

  register(rf) {
    // // console.log(rf);
    const body = {
      WORKSHOP_ID: this.workshopId,
      REGISTER_NAME: rf.name,
      REGISTER_LASTNAME: rf.lastname,
      REGISTER_TYPE: rf.type,
      REGISTER_AFFILIATE: rf.affiliate
    }

    this.activityService.registerWorkshopById(body).subscribe(res => {
      if (res.success) {
        let type = 'workshop'
        const queryParams: Params = { id: this.workshopId, type: type };
        this.router.navigate(
          ['/payment'],
          {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: 'merge',
          });
      }
    }, err => { this.errorMessage = err.message })
  }

  openLogin() {
    this.router.navigate(['login'], { state: { redirect: this.router.url } })
  }

  goToScroll(el: string) {
    this.viewportScroller.scrollToAnchor(el)
  }

  cannotRegist() {
    if (this.role === 'teacher') {
      alert('อาจารย์ไม่สามารถลงทะเบียนได้');
    }
    if (this.role === 'admin') {
      alert('admin ไม่สามารถลงทะเบียนได้');
    }
    if (this.role === 'psychologist') {
      alert('นักจิตวิทยาไม่สามารถลงทะเบียนได้');
    }
  }
}
